import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function WhyChooseUs() {
  const { t } = useTranslation();

  const products = [
    t("whyChooseUs.reasons.reason1"),
    t("whyChooseUs.reasons.reason2"),
    t("whyChooseUs.reasons.reason3"),
    t("whyChooseUs.reasons.reason4"),
    t("whyChooseUs.reasons.reason5"),
    t("whyChooseUs.reasons.reason6"),
    t("whyChooseUs.reasons.reason7"),
    t("whyChooseUs.reasons.reason8"),
    t("whyChooseUs.reasons.reason9"),
    t("whyChooseUs.reasons.reason10"),
  ];

  return (
    <div
      id="porque-elegirnos"
      className="mx-auto px-8 md:px-28 mt-16 xl:flex space-x-0 md:space-x-16 my-16 mx-4 md:mx-0"
    >
      <div className="items-start w-full">
        <div className="relative z-10">
          <p className="mb-8 md:mb-0 md:py-4 text-center leading-[60px] md:text-[55px] text-3xl font-light text-[#222222]">
            {t("whyChooseUs.title")}{" "}
            <span className="font-normal">
              {t("whyChooseUs.titleBold")}
            </span>
            ?
          </p>
          <img
            className="mt-24 mb-8 hidden xl:block object-cover rounded-xl m-auto"
            src="/assets/img/about-us/106.jpg"
            alt="Our Process"
            loading="lazy"
            decoding="async"
          />
          <Link
            className="text-center text-[#0B4797] text-2xl hover:text-[#014F9F] transition-colors"
            to="/sistema-de-calidad"
          >
            {t("whyChooseUs.precisionLink")}
          </Link>
        </div>
      </div>
      <div>
        <p className="w-full md:text-lg text-sm md:text-left text-center font-semibold text-[#0B4797]">
          {t("whyChooseUs.commitment")}
        </p>
        <div className="md:mt-16 mt-4">
          {products.map((product, index) => (
            <div
              className={`${
                index % 2 === 1
                  ? "bg-[#03275A] text-white"
                  : "bg-none text-[#222222]"
              } p-6 space-x-6  w-full rounded-[40px] flex items-center`}
              key={product}
            >
              <p
                className={`${
                  index % 2 === 1 ? "text-white" : "text-[#03275A]"
                } font-bold text-5xl`}
              >
                {String(index + 1).padStart(2, "0")}
              </p>
              <p className="md:text-xl text-base font-semibold text-left">
                {product}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
